export default __webpack_public_path__ + "static/media/sensor2.a390a19f.webp";